/**
 * Avallon MCP server entry point.
 *
 * setupFetch() must run before any generated code is imported, because the
 * generated http-client.ts calls globalThis.fetch at module evaluation time.
 * ESM static imports are hoisted, so we use a dynamic import to guarantee
 * ordering: patch first, then load the generated server.
 *
 * Run `npm run generate` (or `npm run mcp:gen` from the repo root) to
 * regenerate the server from the latest OpenAPI spec before building.
 */

import { setupFetch } from "./setup-fetch.js";

setupFetch();

await import("./generated/server.js");
